import React, { useEffect, useState } from "react";
import Problem from "./Problem";
import Button from "react-bootstrap/esm/Button";
import Container from "react-bootstrap/esm/Container";
import Card from "react-bootstrap/esm/Card";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { CheckLg } from "react-bootstrap-icons";
import toast, { Toaster } from "react-hot-toast";
import BackToGameList from "../../utils/BackToGameList";

function MathCorrect() {
  const [y, setY] = useState();
  const [x, setX] = useState();
  const [newAnswer, setNewAnswer] = useState(true);
  const [correctCounter, setCorrectCounter] = useState(0);
  const [incorrectCounter, setIncorrectCounter] = useState(0);
  const [numOne, setNumOne] = useState(0);
  const [numTwo, setNumTwo] = useState(0);
  const [numThree, setNumThree] = useState(0);
  const [guess, setGuess] = useState("newAnswer");

  const runAnswer = () => {
    if (guess !== "newAnswer") {
      if (y === guess) {
        toast("Congratulations, you've selected the correct answer!", {
          duration: 5000,
          position: "bottom-center",
        });
        setCorrectCounter((prevCount) => prevCount + 1);
      } else {
        toast("Sorry but that is incorrect. Please try again!", {
          duration: 5000,
          position: "bottom-center",
        });
        setIncorrectCounter((prevCount) => prevCount + 1);
      }
      setGuess("newAnswer");
    } else {
    }
  };

  useEffect(() => {
    runAnswer();
  }, [guess]);

  return (
    <>
      <BackToGameList />
      <Container style={{ marginTop: "50px" }}>
        <Card>
          <Row>
            <Col>
              <Problem
                setY={setY}
                guess={guess}
                correct={true}
                setX={setX}
                setNumOne={setNumOne}
                setNumTwo={setNumTwo}
                setNumThree={setNumThree}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "50px", marginBottom: "50px" }}>
            <Col>
              <Button
                variant="danger"
                style={{ width: "40%", fontSize: "60px" }}
                onClick={() => setGuess(false)}
              >
                x
              </Button>
            </Col>
            <Col>
              <Button
                variant="success"
                style={{ width: "40%", fontSize: "60px" }}
                onClick={() => setGuess(true)}
              >
                <CheckLg />
              </Button>
            </Col>
          </Row>
          <Row>
          <Row>
            <Col><div style={{fontSize:'32px', border:'1px solid red', borderRadius:'20px'}}><div style={{borderBottom:'1px solid grey'}}>Number Incorrect</div> <div style={{color:'red'}}>{incorrectCounter}</div></div></Col>
            <Col><div style={{fontSize:'32px', border:'1px solid green', borderRadius:'20px'}}><div style={{borderBottom:'1px solid grey'}}>Number Correct</div> <div style={{color:'green'}}>{correctCounter}</div></div></Col>
          </Row>
          </Row>
        </Card>
      </Container>
    </>
  );
}

export default MathCorrect;
